export const MIN_OBV = -1;
export const MAX_OBV = 1;

export const DEFAULT_MIN_MINUTES = 300;
export const MIN_MINUTES = 0;
export const MAX_MINUTES = 5000;

export const LOW_MINUTES_THRESHOLD = 300;

export const MIN_HEIGHT = 140;
export const MAX_HEIGHT = 210;

export const MIN_AGE = 16;
export const MAX_AGE = 35;

export const MIN_XG = 0;
export const MAX_XG = 1;
